import useDateRangeFilterFields from "./useDateRangeFilterFields";
import useSearchParamGroup from "ui/common/hooks/useSearchParamGroup";

export default function useDateRangeFilter() {
    const rangeFiltersDeclaration = useDateRangeFilterFields();

    return useSearchParamGroup(...rangeFiltersDeclaration);
}
